module.exports = __webpack_public_path__ + "assets/images/project/japan-desktop.jpg?v=ac986f48";